import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { OrgIdContext } from "../store/orgId_context";
import { useCallback } from "react";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const useClients = (setSearchClientsHandler) => {
  const [clientsList, setClientsList] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const { mainOrgId } = useContext(OrgIdContext);
  const [refresh, setRefresh] = useState(0);

  const sortClients = useCallback(
    (list) => {
      return list
        .filter((org) => org.CustomerId !== mainOrgId)
        .sort((a, b) => {
          if (b.ThisMonth === a.ThisMonth) {
            // Sort by client name if ThisMonth values are equal
            return a.Organisation.localeCompare(b.Organisation);
          }
          // Sort by ThisMonth in descending order
          return b.ThisMonth - a.ThisMonth;
        });
    },
    [mainOrgId]
  );

  const reload = () =>{
    setRefresh(current => current+1);
  }

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetTCustomers",
          },
          id: 17,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setRefresh(false);
        if (res?.data?.result?.Result) {
          const sortedClients = sortClients(res?.data?.result?.Result);
          setClientsList(sortedClients);
          setSearchClientsHandler(sortedClients);
        }
        setIsLoaded(true);
      });
  }, [mainOrgId, setSearchClientsHandler, sortClients, refresh]);

  return { clientsList, isLoaded, reload };
};

export default useClients;
